import React, { useMemo } from "react";

const SuccessIcon = ({ width = 19, height = 19 }) => {
  const svgContent = useMemo(() => {
    return (
      <svg
        id="Group_31142"
        data-name="Group 31142"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 19 19"
      >
        <circle
          id="Ellipse_229"
          data-name="Ellipse 229"
          cx="8.5"
          cy="8.5"
          r="8.5"
          transform="translate(0.639 1)"
          fill="#fff"
        />
        <path
          id="success-filled-svgrepo-com"
          d="M73.5,64A9.5,9.5,0,1,1,64,73.5,9.5,9.5,0,0,1,73.5,64ZM72.361,74.578l-2.11-2.112a.989.989,0,0,0-1.282.109,1.226,1.226,0,0,0,.131,1.445l2.687,2.687a.812.812,0,0,0,1.152,0L78.5,71.143a1.047,1.047,0,0,0,.109-1.5,1.028,1.028,0,0,0-1.479.114Z"
          transform="translate(-64 -64)"
          fill="#05ab56"
        />
      </svg>
    );
  }, []);
  return svgContent;
};

export default SuccessIcon;



// WEBPACK FOOTER //
// ./src/assets/SuccessIcon.jsx